{
	"titlePage": "Transferencias de stock",
	"tabLabel": "Transferencias",
	"description": "Este informe permite seguir los movimientos entre existencias proporcionando una visibilidad adecuada de las transferencias para almacenistas y gestores.",
	"actionButtons": {
		"print": "Imprimir",
		"downloadExcel": "Descargar en Excel"
	},
	"filterToPeriod": "Filtrar por período",
	"column": {
		"dateTransfer": "Fecha de transferencia",
		"employee": "Empleado",
		"outgoingStock": "Stock de salida",
		"incomingStock": "Stock de entrada",
		"inputAndProduct": "Insumo/Producto",
		"amount": "Cantidad"
	},
	"employeePlaceholder": "Empleado",
	"storagePlaceholder": "Stock",
	"searchBy": "Buscar por"
}
